import { PropTypes }       from 'prop-types';
import TimelineActivity    from '~/components/drawers/timeline/activity';

class TimelineActivityBucket extends TimelineActivity {}

const BUCKET_MAPPING = {
  archived: 'Archived',
  backlog:  'Backlog',
  default:  'Normal',
};

TimelineActivityBucket.defaultProps = {
  title:  ({ props: { activity: { owner, parameters: { bucket, previous_bucket } } } }) => {
    const previous_bucket_text = previous_bucket ? `from ${BUCKET_MAPPING[previous_bucket] || previous_bucket} ` : '';
    const owner_text = owner?.name ? ` by ${owner.name}` : '';
    const bucket_text = BUCKET_MAPPING[bucket] || bucket;

    return `Moved ${previous_bucket_text}to ${bucket_text}${owner_text}`;
  },
  icon:           'exchange-alt',
  prefix:         'fas',
  alwaysPublic:   false,
};

TimelineActivityBucket.propTypes = {
  editable:  PropTypes.bool,
  deletable: PropTypes.bool,
  title:     PropTypes.func,
  icon:      PropTypes.string,
  prefix:     PropTypes.string,
  color:     PropTypes.string,
};

export default TimelineActivityBucket;
